<div class="row" *ngIf="isEnabled">
  <div class="col-60 bg-gray p-2 align-items-center"
       (click)="this.navigateToLink()">
    <p class="elsa-title-font text-center text-uppercase m-0">{{'label_header_link_in_evidence' | translate}}</p>
  </div>
</div>
